import React from 'react';
import cx from 'classnames';

import CustomFieldEmail from '../EmailField';
import CustomFieldAddressAutocomplete from '../AddressAutocompleteField';

const CustomField = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched, values },
  ...props
}) => {
  const fieldClasses = cx('form-control', {
    'is-invalid': touched[field.name] && errors[field.name],
  });

  if (props.type === 'textarea') {
    return (
      <div>
        {props.label && <label className="control-label">{props.label}</label>}
        <textarea
          aria-label={props.placeholder}
          className={fieldClasses}
          rows={6}
          {...field}
          {...props}
        />
        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  } else if (props.type === 'radio') {
    const keys = Object.keys(props.values);

    const radioClasses = cx('radio', 'form-radio', {
      'is-invalid': touched[field.name] && errors[field.name],
    });

    return (
      <div>
        {keys.map(key => {
          const value = props.values[key];

          return (
            <div className={radioClasses} key={key}>
              <label>
                <input
                  className="form-radio-input"
                  checked={values[field.name] === key}
                  type="radio"
                  onClick={() => {
                    setFieldValue(field.name, key);
                  }}
                />
                <span>{value}</span>
              </label>
            </div>
          );
        })}
        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  } else if (props.type === 'select') {
    const keys = Object.keys(props.values);

    return (
      <div>
        {props.label && (
          <label className="control-label" htmlFor={field.name}>
            {props.label}
          </label>
        )}
        <select className={fieldClasses} id={field.name} {...field} {...props}>
          <option value="" disabled>
            Choose a response
          </option>

          {keys.map(key => {
            const value = props.values[key];

            return (
              <option key={key} value={value.value}>
                {value.label}
              </option>
            );
          })}
        </select>
        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  } else if (props.type === 'checkbox') {
    const checkboxClasses = cx('checkbox', 'form-check', {
      'is-invalid': touched[field.name] && errors[field.name],
    });

    return (
      <div className={checkboxClasses}>
        <label>
          <input
            type="checkbox"
            className="form-check-input"
            {...field}
            {...props}
            value={true}
          />
          <span>{props.label}</span>
        </label>
        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  } else if (props.type === 'address') {
    const addressClassNames = cx({
      'is-invalid': touched[field.name] && errors[field.name],
    });

    const showInvalid = touched[field.name] && errors[field.name];

    return (
      <>
        <CustomFieldAddressAutocomplete
          className={addressClassNames}
          placeholder={props.placeholder}
          setFieldValue={setFieldValue}
        />
        {touched[field.name] && (
          <div
            className="invalid-feedback"
            style={{
              display: showInvalid ? 'block' : 'auto',
            }}
          >
            {errors[field.name]}
          </div>
        )}
      </>
    );
  } else if (props.type === 'email') {
    const emailInvalid = touched[field.name] && errors[field.name];

    return (
      <CustomFieldEmail
        className={fieldClasses}
        error={errors[field.name]}
        isInvalid={emailInvalid}
        setFieldValue={setFieldValue}
        {...field}
        {...props}
      />
    );
  } else if (props.type === 'checkbox_group') {
    const checkboxGroupInvalid = touched[field.name] && errors[field.name];

    return (
      <div>
        {props.label && <label className="control-label">{props.label}</label>}

        {props.values.map((valueGroup, key) => {
          return (
            <div key={key} className="form-check">
              <label>
                <input
                  type="checkbox"
                  name={valueGroup.value}
                  value={valueGroup.value}
                  className="form-check-input"
                  onChange={event => {
                    props.onChange(event, valueGroup.value);
                    setFieldTouched(field.name);
                    setFieldValue(valueGroup.value, event.target.checked);
                  }}
                />
                <span>{valueGroup.label}</span>
              </label>
            </div>
          );
        })}

        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  } else if (props.type === 'radio_group') {
    const checkboxGroupInvalid = touched[field.name] && errors[field.name];

    return (
      <div>
        {props.label && <label className="control-label">{props.label}</label>}

        {props.values.map((valueGroup, key) => {
          return (
            <div key={key} className="form-radio">
              <label>
                <input
                  type="radio"
                  name={field.name}
                  value={valueGroup.value}
                  className="form-radio-input"
                  onChange={event => {
                    props.onChange(event, valueGroup.value);
                    setFieldTouched(field.name);
                    setFieldValue(field.name, valueGroup.value);
                  }}
                />
                <span>{valueGroup.label}</span>
              </label>
            </div>
          );
        })}

        {touched[field.name] && (
          <div className="invalid-feedback">{errors[field.name]}</div>
        )}
      </div>
    );
  }

  return (
    <div>
      {props.label && <label className="control-label">{props.label}</label>}
      <input
        className={fieldClasses}
        type="text"
        aria-label={props.placeholder}
        {...field}
        {...props}
      />
      {touched[field.name] && (
        <div className="invalid-feedback">{errors[field.name]}</div>
      )}
    </div>
  );
};

export default CustomField;
